import { createSlice } from "@reduxjs/toolkit";
import { OrdersAPI } from "../../services/orders";

const Orders = createSlice({
  name: "Orders",
  initialState: {
    orders: [],
    loading: false,
    oneOrder: null,
    total: 0,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(OrdersAPI.getAll.fulfilled, (state, action) => {
        const { orders, total } = action.payload;

        state.orders = orders;
        state.total = total;
      })

      .addCase(OrdersAPI.getOne.fulfilled, (state, action) => {
        state.oneOrder = action.payload.data;
        state.loading = false;
      })

      .addCase(OrdersAPI.getOne.pending, (state) => {
        state.loading = true;
      })
    
      .addCase(OrdersAPI.getOne.rejected, (state) => {
        state.loading = false;
      });
  },
});

export default Orders;
